<div class="modal-all">
  <!-- CABECERA -->
  <div class="modal-header">
    <span
      class="modal-header-text"
      [innerHTML]="
        'modal-assign-driver.title'
          | translate
            : {
                label:
                  filter === 'sweeper'
                    ? ('modal-assign-driver.sweeperLabel' | translate)
                    : ''
              }
      "
    ></span>
  </div>

  <!-- CUERPO -->
  <div class="modal-body">
    <div class="form-group" *ngIf="!(loading$ | async)">
      <p
        [innerHTML]="
          'modal-assign-driver.driver_summary'
            | translate
              : {
                  count: (visibleDrivers$ | async)?.length ?? 0,
                  time: getCurrentHourAndMinute(),
                  serviceType: serviceTypeLabel,
                  plate: serviceInfo.licensePlate
                }
        "
      ></p>
    </div>

    <form
      [formGroup]="assignForm"
      id="assignForm"
      (ngSubmit)="assign()"
      class="assign-form-container"
    >
      <!-- Búsqueda -->
      <div
        class="row"
        *ngIf="!(loading$ | async) || (visibleDrivers$ | async)?.length"
      >
        <div class="col-12">
          <tui-input
            class="input_form"
            tuiTextfieldIconLeft="tuiIconSearch"
            [tuiTextfieldLabelOutside]="true"
            [formControl]="searchControl"
            [disabled]="!!(loading$ | async)"
          >
            {{ "modal-assign-driver.search_drivers" | translate }}
          </tui-input>
        </div>
      </div>

      <!-- LISTA DE CONDUCTORES -->
      <div class="form-group">
        <ng-container *ngIf="!(loading$ | async); else loadingTpl">
          <ng-container
            *ngIf="visibleDrivers$ | async as drivers; else noDataTpl"
          >
            <ng-container *ngIf="drivers.length; else noDriversTpl">
              <div
                class="driver"
                *ngFor="let driver of drivers; trackBy: trackByDriverId"
                (click)="selectDriver(driver.driverId)"
                [class.driver--selected]="
                  assignForm.value.driverId === driver.driverId
                "
              >
                <div class="driver-container">
                  <span>{{ driver.name }}</span>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-template #loadingTpl>
          <div class="loading-indicator">
            <tui-loader size="m"></tui-loader>
          </div>
        </ng-template>

        <ng-template #noDataTpl>
          <div class="no-data align-center">
            {{ "modal-assign-driver.no_data" | translate }}
          </div>
        </ng-template>

        <ng-template #noDriversTpl>
          <div class="no-drivers align-center">
            {{ "modal-assign-driver.no_drivers" | translate }}
          </div>
        </ng-template>
      </div>
    </form>
  </div>

  <!-- PIE -->
  <div class="modal-footer">
    <button
      tuiButton
      type="button"
      class="tui-space_right-3 tui-space_bottom-3 btn_desc but_footer"
      size="m"
      appearance="secondary"
      (click)="close()"
    >
      {{ "modal-assign-driver.discard" | translate }}
    </button>

    <button
      tuiButton
      type="submit"
      form="assignForm"
      class="tui-space_right-3 tui-space_bottom-3 but_footer"
      size="m"
      appearance="primary-button"
      icon="tuiIconPlusCircleLarge"
      [disabled]="assignForm.invalid || !!(loadingAssign$ | async)"
    >
      <ng-container *ngIf="loadingAssign$ | async; else assignLabel">
        <tui-loader size="xs"></tui-loader>
      </ng-container>
      <ng-template #assignLabel>
        {{ "modal-assign-driver.assign" | translate }}
      </ng-template>
    </button>
  </div>
</div>
